import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { sendStaffResetOtp } from '../api/staff.js';

const inputClass =
  'w-full rounded-lg border border-slate-300 px-4 py-3 text-base font-semibold text-slate-900 outline-none transition placeholder:font-normal placeholder:text-slate-400 focus:border-brand-accent focus:ring-2 focus:ring-brand-accent/20';

function ForgotPassword() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [mobile, setMobile] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (!username.trim() || !mobile.trim()) {
      setError('Please enter username and mobile number');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    const result = await sendStaffResetOtp(username.trim(), mobile.trim());
    setLoading(false);

    if (!result.ok) {
      setError(result.error || 'Failed to send OTP');
      return;
    }

    setSuccess(result.message || 'OTP sent');
    setCountdown(60);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    navigate('/reset-password', { state: { username: username.trim(), mobile: mobile.trim() } });
  };

  return (
    <div className="mx-auto flex min-h-screen w-full max-w-md flex-col bg-slate-50">
      <div className="relative bg-brand-primary px-6 py-10 text-white">
        <Link
          to="/login"
          className="absolute left-4 top-4 rounded-full bg-white/10 p-2 transition hover:bg-white/20"
        >
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-bold">Forgot Password</h1>
        <p className="mt-1 text-sm text-slate-300">We will send an OTP to your mobile</p>
      </div>

      <div className="flex-1 p-6">
        <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <form onSubmit={handleSendOtp} className="space-y-4">
            <div>
              <label htmlFor="username" className="mb-2 block text-sm font-medium text-slate-700">
                Username <span className="text-red-500">*</span>
              </label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className={inputClass}
                placeholder="Your staff name"
                required
              />
            </div>

            <div>
              <label htmlFor="mobile" className="mb-2 block text-sm font-medium text-slate-700">
                Mobile <span className="text-red-500">*</span>
              </label>
              <input
                id="mobile"
                type="tel"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className={inputClass}
                placeholder="Registered mobile number"
                required
              />
            </div>

            {error && <p className="text-sm text-red-600">{error}</p>}
            {success && <p className="text-sm text-green-600">{success}</p>}

            <button
              type="submit"
              disabled={loading || countdown > 0}
              className="w-full rounded-lg bg-brand-accent py-3 text-base font-semibold text-white transition hover:bg-blue-700 disabled:opacity-60"
            >
              {loading ? 'Sending…' : countdown > 0 ? `Resend in ${countdown}s` : 'Send OTP'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
